import styled from 'styled-components'

const Style = {
	Container: styled.div`
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 20px;
		padding: 32px 16px;
		background-color: ${({theme}) => theme.color.white || '#FFFFFF'};
		min-height: calc(100dvh - 96px);
		width: 375px;
		max-width: 100%;
		margin: 0 auto;

		@media (max-width: ${({theme}) => theme.breakpoints.mobile || '768px'}) {
			padding: 24px 16px;
			width: 100%;
		}
	`,

	ScanIcon: styled.img`
		width: 96px;
		height: 96px;
		object-fit: cover;
		}
	`,

	Title: styled.h1`
		${({theme}) => theme.font.large_bold || theme.font.large};
		color: ${({theme}) => theme.color.black || '#1F2024'};
		text-align: center;
		margin: 0;
		font-size: 20px;
		font-weight: 700;
		line-height: 1.2;

		@media (max-width: ${({theme}) => theme.breakpoints.mobile || '768px'}) {
			font-size: 18px;
		}
	`,

	InstructionsContainer: styled.div`
		display: flex;
		flex-direction: column;
		align-self: stretch;
		gap: 8px;
		width: 100%;
	`,

	Instructions: styled.p`
		${({theme}) => theme.font.small || theme.font.medium};
		color: ${({theme}) => theme.color.black || '#1F2024'};
		text-align: center;
		margin: 0;
		width: 100%;
		font-size: 16px;
		line-height: 1.2;
	`,

	ActionContainer: styled.div`
		display: flex;
		flex-direction: column;
		align-items: center;
		align-self: stretch;
		gap: 16px;
		padding: 12px 12px 0px;
		width: 100%;
	`,

	Button: styled.button`
		${({theme}) => theme.font.small || theme.font.medium};
		background-color: ${({theme}) => theme.color.major || '#006FFD'};
		color: ${({theme}) => theme.color.white || '#FFFFFF'};
		display: flex;
		flex-direction: row;
		justify-content: center;
		align-items: center;
		align-self: stretch;
		gap: 10px;
		padding: 8px 16px;
		border: none;
		border-radius: 6px;
		cursor: pointer;
		transition: all 0.2s ease;
		width: 100%;
		min-height: 44px;
		text-align: center;
		font-weight: 700;
		font-size: 12px;
		line-height: 1.2;

		&:hover {
			background-color: ${({theme}) => theme.color.major_dark || '#0056CC'};
			transform: translateY(-1px);
		}

		&:active {
			transform: translateY(0);
		}

		&:focus {
			outline: 2px solid ${({theme}) => theme.color.major || '#006FFD'};
			outline-offset: 2px;
		}
	`,

	OrContainer: styled.div`
		display: flex;
		flex-direction: row;
		justify-content: center;
		align-items: center;
		align-self: stretch;
		gap: 2px;
		width: 100%;
	`,

	OrText: styled.p`
		${({theme}) => theme.font.small_bold || theme.font.small};
		color: ${({theme}) => theme.color.black || '#1F2024'};
		text-align: center;
		margin: 0;
		font-weight: 700;
		font-size: 16px;
		line-height: 1.2;
	`,
}

export default Style
